<section class="pn-pdf" *ngIf="estructura as e">
  <header class="pn-pdf__header" id="pdf-header">
    <div class="pn-pdf__header-top">
      <div class="pn-pdf__header-left">
        <img class="pn-pdf__logo" [src]="logoSrc" alt="Logo INDAP" />
      </div>
      <div class="pn-pdf__header-right">
        <div class="pn-pdf__header-right-line">Plataforma Programa SAT</div>
        <div class="pn-pdf__header-right-line">Gestión de Asesorías Técnicas</div>
      </div>
    </div>
  </header>

  <main class="pn-pdf__content">
    <div id="pdf-section-header">
      <div class="pn-pdf__header-title">Plan de Negocio</div>

      <div class="pn-pdf__datos">
        <div class="pn-pdf__dato">
          <h2 class="pn-pdf__h2">Identificación del Plan de Negocio</h2>
        </div>
        <div class="pn-pdf__dato">
          <span class="pn-pdf__dato-label">Usuario INDAP / Productor(a):</span>
          <span class="pn-pdf__dato-value">{{ meta?.productor || e.productor || e.caracterizacion?.productor || '-' }}</span>
        </div>
        <div class="pn-pdf__dato">
          <span class="pn-pdf__dato-label">RUN/RUT:</span>
          <span class="pn-pdf__dato-value">{{ meta?.rut || e.rut || e.caracterizacion?.rut || '-' }}</span>
        </div>
        <div class="pn-pdf__dato">
          <span class="pn-pdf__dato-label">Unidad Operativa:</span>
          <span class="pn-pdf__dato-value">{{ meta?.unidad_operativa || e.unidad_operativa || e.caracterizacion?.unidad_operativa || '-' }}</span>
        </div>
        <div class="pn-pdf__dato">
          <span class="pn-pdf__dato-label">Agencia de Área:</span>
          <span class="pn-pdf__dato-value">{{  e.agencia_area  || '-' }}</span>
        </div>
        <div class="pn-pdf__dato">
          <span class="pn-pdf__dato-label">Rubro Principal:</span>
          <span class="pn-pdf__dato-value">{{ e.rubro_principal || e.caracterizacion?.rubro_principal || '-' }}</span>
        </div>
        <div class="pn-pdf__dato">
          <span class="pn-pdf__dato-label">Elaborado por Asesor(a):</span>
          <span class="pn-pdf__dato-value">{{ e.elaborado_por || e.caracterizacion?.elaborado_por || '-' }}</span>
        </div>
        <div class="pn-pdf__dato">
          <h2 class="pn-pdf__h2">Seguimiento del Proceso</h2>
        </div>
        <div class="pn-pdf__dato">
          <span class="pn-pdf__dato-label">Fecha de inicio de elaboración:</span>
          <span class="pn-pdf__dato-value">{{ formatearFechaIsoHora(e.inicio_elaboracion) || '-' }}</span>
        </div>
        <div class="pn-pdf__dato">
          <span class="pn-pdf__dato-label">Fecha de envío para aprobación:</span>
          <span class="pn-pdf__dato-value">{{ formatearFechaIsoHora(e.ultima_fecha_envio_aprobacion) || '-' }}</span>
        </div>
        <div class="pn-pdf__dato">
          <span class="pn-pdf__dato-label">Aprobado por:</span>
          <span class="pn-pdf__dato-value">{{ e.aprobado_por || e.caracterizacion?.aprobado_por || '-' }} {{ e.perfil_aprobador ? '('+ e.perfil_aprobador +')' : "" }}</span>
        </div>
        <div class="pn-pdf__dato">
          <span class="pn-pdf__dato-label">Fecha de Aprobación:</span>
          <span class="pn-pdf__dato-value">{{ formatearFechaIsoHora(e.fecha_aprobacion || e.caracterizacion?.fecha_aprobacion) || '-' }}</span>
        </div>
        <div class="pn-pdf__dato">
          <span class="pn-pdf__dato-label">Estado:</span>
          <span class="pn-pdf__dato-value">{{ meta?.estado || e.estado || e.caracterizacion?.estado || '-' }}</span>
        </div>
      </div>
    </div>

    <section class="pn-pdf__section" *ngIf="(e.resumen_problemas?.length ?? 0) > 0" id="pdf-section-1">
      <h2 class="pn-pdf__h2">1. Resumen de Problemas Detectados y Priorización</h2>
      <table class="pn-pdf__table pn-pdf__table--boxed">
        <thead>
          <tr>
            <th>Área de gestión</th>
            <th>Rubro</th>
            <th style="width: 40%">Descripción del hallazgo</th>
            <th style="width: 20%">Priorización</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let it of e.resumen_problemas">
            <td>{{ it.area_gestion || '-' }}</td>
            <td>{{ it.rubro || '-' }}</td>
            <td>{{ it.hallazgo || '-' }}</td>
            <td>{{ it.priorizacion ?? '-' }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <section class="pn-pdf__section" *ngIf="(e.soluciones_tecnicas?.length ?? 0) > 0" id="pdf-section-2">
      <h2 class="pn-pdf__h2">2. Soluciones técnicas</h2>
      <ng-container *ngFor="let g of solucionesTecnicasAgrupadas">
        <div class="pn-pdf__grupo-titulo">Rubro: {{ g.rubro }}</div>

        <ng-container *ngFor="let area of g.areas">
          <table class="pn-pdf__table pn-pdf__table--boxed pn-pdf__table--soluciones">
            <thead>
              <tr class="pn-pdf__area-row">
                <th colspan="5">Área de Gestión: {{ area.area }}</th>
              </tr>
              <tr>
                <th style="width: 20%">Hallazgo</th>
                <th style="width: 50%">Asesoría Técnica Individual</th>
                <th style="width: 20%">Actividades Grupales</th>
                <th style="width: 10%">Inversión Necesaria</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let it of area.items">
                <td>{{ it.hallazgo || '-' }}</td>
                <td><div class="bold"><b>{{ it.titulo || '-' }}</b></div><div>{{ it.asesoria_individual || '-' }}</div></td>
                <td class="pn-pdf__cell-pre">{{ textoActividadesGrupales(it.asesoria_especializada) }}</td>
                <td>{{ textoBool(it.requiere_inversion) || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </ng-container>
      </ng-container>
    </section>

  <section class="pn-pdf__section" *ngIf="(e.plan_trabajo?.length ?? 0) > 0" id="pdf-section-3">
  
  <ng-container  *ngFor="let g of ciclosAgrupados; let i = index">
  <div id="ciclo-block-{{i}}" class="ciclo-block">
    <h2 *ngIf="i === 0" class="pn-pdf__h2">3. Plan de trabajo</h2>
    <div class="pn-pdf__grupo-titulo">Ciclo {{ g.ciclo }}</div>

    <!-- Tabla de visitas del ciclo -->
    <table class="pn-pdf__table pn-pdf__table--boxed">
      <thead>
        <tr>
          <th>Visita</th>
          <th>Fecha de Inicio</th>
          <th>Fecha de Término</th>
          <th>Temas</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let it of g.plan">
          <td>{{ it.nombre || '-' }}</td>
          <td>{{ formatearFechaIso(it.fecha_inicio) || '-' }}</td>
          <td>{{ formatearFechaIso(it.fecha_termino) || '-' }}</td>
          <td>
            <div *ngIf="(it.temas?.length ?? 0) > 0; else noTemas">
              <div *ngFor="let tema of it.temas" class="tema-item">- {{ tema }}</div>
            </div>
            <ng-template #noTemas>-</ng-template>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Cronogramas por año dentro del ciclo -->
    <ng-container *ngFor="let bloque of g.cronograma; let idx = index">
      <div class="pn-pdf__grupo-tituloCrono">
        Cronograma de Ejecución (Ciclo {{ g.ciclo }}, {{ bloque.rangoInicio | date:'MMM yyyy' }} – {{ bloque.meses[11] }} {{ bloque.rangoInicio.getFullYear() + 1 }})
      </div>
      <table class="pn-pdf__table pn-pdf__table--cronograma">
        <thead>
          <tr>
            <th>Actividad</th>
            <th *ngFor="let mes of bloque.meses">{{ mes }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let visita of getVisitasTg(bloque.items)">
            <td>{{ truncateNombre(visita.nombre) }}</td>
            <td *ngFor="let mes of bloque.meses; let i = index"
                [class.cell-activaTG]="estaEnMes(visita, mes, obtenerYearParaMes(bloque.rangoInicio, i), bloque.meses)">
            </td>
          </tr>
          <tr *ngFor="let visita of getVisitas(bloque.items)">
            <td>{{ truncateNombre(visita.nombre) }}</td>
            <td *ngFor="let mes of bloque.meses; let i = index"
                [class.cell-activa]="estaEnMes(visita, mes, obtenerYearParaMes(bloque.rangoInicio, i), bloque.meses)">
            </td>
          </tr>
          <tr *ngFor="let visita of getVisitasAg(bloque.items)">
            <td>{{ truncateNombre(visita.nombre) }}</td>
            <td *ngFor="let mes of bloque.meses; let i = index"
                [class.cell-activaAG]="estaEnMes(visita, mes, obtenerYearParaMes(bloque.rangoInicio, i), bloque.meses)">
            </td>
          </tr>
        </tbody>
        <tfoot>
        <tr>
          <td [attr.colspan]=" bloque.meses.length + 1">
            <table>
              <tr>
                <td class="cell-activaTG">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td><td>Temas de Gestión&nbsp;&nbsp;&nbsp;</td>
                <td class="cell-activa">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td><td>Asesoría Técnica&nbsp;&nbsp;&nbsp;</td>
                <td class="cell-activaAG">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td><td>Actividades Grupales&nbsp;&nbsp;&nbsp;</td>
              </tr>
            </table>
          </td>
        </tr>
      </tfoot>
      </table>
    </ng-container>
  </div>
  </ng-container> 

</section>

    <section class="pn-pdf__section" *ngIf="(e.plan_inversion?.length ?? 0) > 0" id="pdf-section-4">
      <h2 class="pn-pdf__h2">4. Plan de inversión</h2>
      <ng-container *ngFor="let g of planInversionAgrupadoPorRubro">
        <div class="pn-pdf__grupo-titulo">Rubro: {{ g.rubro }}</div>
        <table class="pn-pdf__table pn-pdf__table--boxed">
          <thead>
            <tr>
              <th style="width: 70%">Solución</th>
              <th style="width: 10%">Tipo</th>
              <th style="width: 10%">Costo total</th>
              <th style="width: 10%">Cronograma</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let it of g.items">
              <td><b>{{ it.solucion || '-' }}</b><br>
                {{ it.descripcion_inversion || '-' }}</td>
              <td>{{ it.tipo || '-' }}</td>
              <td>{{ formatCLP(it.costo_total) }}</td>
              <td>{{ formatCronograma(it.cronograma) }}</td>
            </tr>
          </tbody>
        </table>
      </ng-container>
    </section>

    <div class="pn-pdf__signature" id="pdf-signature">
      <div class="pn-pdf__firma-line" aria-hidden="true"></div>
      <div class="pn-pdf__firma-label">Firma</div>
    </div>

    <footer class="pn-pdf__footer" id="pdf-footer">
      Descargado el {{ ahora }}
    </footer>
  </main>
</section>

